import React from 'react';
import type { MapRegionsMGProps } from '../../../types';
import { MAP_REGIONS, getAllRegionNames } from './MapData';
import { useMapInteraction } from './useMapInteraction';
import MapRegion from './MapRegion';
import MapDialog from './MapDialog';

const MAP_RENDER_ORDER = [
  'Norte',
  'Centro',
  'Sul',
  'Jequitinhonha',
  'Centro-oeste',
  'Rio-doce',
  'Zona-da-mata',
  'Triangulo',
  'Noroeste',
];

const normalizeText = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const MGMap: React.FC<MapRegionsMGProps> = ({
  'map-title': mapTitle = 'Encontre o Sebrae mais perto de você.',
  'map-content': mapContent = 'Entre em contato com o Sebrae da sua região para obter orientações personalizadas para o seu negócio.',
  regions = []
}) => {
  const { selectedRegion, handleRegionClick, handleCloseDialog } = useMapInteraction(regions);
  const normalizedMapTitle = normalizeText(mapTitle);
  const resolvedMapTitle = [
    'encontre o sebrae mais proximo de voce',
    'encontre o seu sebrae',
    'encontre seu sebrae',
  ].includes(normalizedMapTitle)
    ? 'Encontre o Sebrae mais perto de você.'
    : mapTitle;

  return (
    <section id="mapa-mg" className="w-full py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto p-8 mb-0 md:mb-10 lg:mb-10">
        <h2 className="text-2xl font-bold text-gray-700 mb-2">{resolvedMapTitle}</h2>
        <p className="text-gray-600 mb-4">{mapContent}</p>
      </div>

      <div className="w-full max-w-4xl mx-auto px-4 py-6 flex flex-col items-center">
        <svg
          viewBox="0 0 855 663"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-auto"
          style={{ maxWidth: '100%', height: 'auto' }}
        >
          {MAP_RENDER_ORDER.filter((regionName) => getAllRegionNames().includes(regionName)).map((regionName) => {
            const regionData = MAP_REGIONS[regionName];
            if (!regionData) {
              console.warn(`Dados não encontrados para região: ${regionName}`);
              return null;
            }

            return (
              <MapRegion
                key={regionName}
                regionData={regionData}
                onClick={handleRegionClick}
              />
            );
          })}
        </svg>
      </div>

      <MapDialog
        region={selectedRegion}
        onClose={handleCloseDialog}
        allRegions={regions}
      />
    </section>
  );
};

export default MGMap;
